module.exports = __webpack_public_path__ + "static/media/airport-origin.46cf7700.svg";